import { useCustomMutation } from '../../graphql';
import { useSetCurrentWorkspace } from './useSetCurrentWorkspace';

interface ChangeWorkspaceResponse {
  account?: { changeWorkspace?: { success?: boolean } };
}

export const useChangeWorkspace = () => {
  const { mutateAsync: setCurrentWorkspace } = useSetCurrentWorkspace();
  return useCustomMutation({
    query: CHANGE_WORKSPACE,
    options: {
      // A real switch replaces the caller's roles server-side, so a Global
      // Admin loses `*.*`. A workspace still stored from the Impersonate
      // picker would keep every query pointed at it, and the API refuses each
      // one. Awaited here so it is cleared before callers refetch or reload.
      onSuccess: async (data: unknown) => {
        const result = (data as ChangeWorkspaceResponse | undefined)?.account
          ?.changeWorkspace;
        if (result?.success) {
          await setCurrentWorkspace(undefined);
        }
      },
    },
  });
};

const CHANGE_WORKSPACE = `
  mutation ChangeWorkspace($input: ChangeWorkspaceInput!) {
    account {
      changeWorkspace(input: $input) {
        success,
        message
      }
    }
  }
`;
